import { memo } from "react";
import { styled } from "styled-components";

import { SectionTitleUnderlined, SourceLabel } from "common/components";
import { ListImage, ListLink } from "common/components/lists/ListLink";
import { breakWordStyle, lineTruncationStyle } from "common/styles";
import type { Source } from "entities/knowledge/types";

const StyledTitle = styled(SectionTitleUnderlined)`
  & > h2 {
    font-weight: bold;
    font-size: 1.1rem;
    line-height: 1.5rem;
  }
  margin-top: 8px;
  margin-bottom: 16px;

  ${lineTruncationStyle(2)}
`;

const StyledSummary = styled.p`
  font-size: 0.9rem;
  line-height: 1.4rem;
  margin: 0;
  flex-grow: 1;
  color: ${({ theme }) => theme.colors.clusterCaptionText};

  ${breakWordStyle}
  ${lineTruncationStyle(3)};
`;

const StyledContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  margin: 0;
`;

const StyledImage = styled(ListImage)`
  border-radius: 10px;
  width: 120px;
  min-width: 120px;
  height: 90px;
`;

const StyledRow = styled.div`
  display: flex;
  height: 100%;
`;

type PublicationItemProps = {
  title: string;
  description?: string;
  imageUrl?: string;
  source: Source;
  timestamp: number;
  isSelected?: boolean;
  link: string;
  onClick?: () => void;
};

// TODO: Replace ArticleItem with this new component once the old Knowledge type is removed
export const PublicationItem = memo(
  ({ title, description, imageUrl, source, timestamp, link, isSelected, onClick }: PublicationItemProps) => (
    <StyledRow>
      <ListLink to={link} onClick={onClick} $isSelected={isSelected}>
        {source && <SourceLabel source={source} date={timestamp} type="small" />}
        <StyledTitle>{title}</StyledTitle>
        <StyledContent>
          <div style={{ marginRight: "1rem" }}>
            <StyledImage src={imageUrl} />
          </div>
          <StyledSummary>{description}</StyledSummary>
        </StyledContent>
      </ListLink>
    </StyledRow>
  ),
);

PublicationItem.displayName = "PublicationItem";
